// extracted by mini-css-extract-plugin
export default {"title":"salaryChart_title__9EtR6"};